/*  ========================================================================
    # Scripts - Video Lightbox
    ========================================================================  */

/**
 * Script to handle video lightbox.
 */

import { animate } from 'motion';

const FormLightbox = {
  cfg: {
    dialogContainer: document.querySelectorAll('.s-cta__dialog'),
    dialogTrigger: document.querySelectorAll('[data-form-lightbox="cta-form-lightbox"]')
  },

  handleLightboxToggle() {
    this.cfg.dialogTrigger.forEach((trigger, index) => {
      const dialog = this.cfg.dialogContainer[index];
      const wrapper = dialog.querySelector('.s-cta__dialog-wrapper');
      const close = dialog.querySelector('.s-cta__dialog-close');

      trigger.addEventListener('click', () => {
        dialog.showModal();
        animate(dialog, {
          opacity: 1,
          visibility: 'visible'
        });
        animate(wrapper, {
          y: [50, 0],
          scale: [0.95, 1]
        });
      });

      const closeAnimation = () => {
        animate(dialog, {
          opacity: 0,
          visibility: 'hidden'
        });
        animate(wrapper, {
          y: [0, 50],
          scale: [1, 0.95]
        });
      };

      close.addEventListener('click', () => {
        closeAnimation();
        trigger.focus();
        dialog.close();
      });

      dialog.addEventListener('close', () => {
        closeAnimation();
      });
    });
  },

  handleFormDatepickerPosition() {
    // Check if datepicker is present and move it into the dialog
    setTimeout(() => {
      const datepickers = document.querySelectorAll('.flatpickr-calendar');
      const datepickerInputs = document.querySelectorAll('.pikaday__container');
      if (datepickerInputs.length > 0 && datepickers.length > 0) {
        datepickerInputs.forEach((input, index) => {
          input.appendChild(datepickers[index]);
        });
      }
    }, 2000);
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.dialogContainer.length > 0 && this.cfg.dialogTrigger.length > 0) {
      this.handleLightboxToggle();
      this.handleFormDatepickerPosition();
    }
  }
};

export default FormLightbox;
